// @flow
import MoreLink from './MoreLink';

export default MoreLink;
